import { useEffect, useRef } from 'react'
import { env } from './config.js'

let scriptPromise

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile)
  if (scriptPromise) return scriptPromise
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-ua-turnstile]')
    const script = existing || document.createElement('script')
    const ready = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('turnstile_unavailable'))
    script.addEventListener('load', ready, { once: true })
    script.addEventListener('error', reject, { once: true })
    if (!existing) {
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      script.async = true
      script.defer = true
      script.dataset.uaTurnstile = 'true'
      document.head.append(script)
    }
  })
  return scriptPromise
}

export default function TurnstileWidget({ language, onToken, onError, verified, verifiedLabel }) {
  const containerRef = useRef(null)

  useEffect(() => {
    let active = true
    let widgetId
    onToken('')
    loadTurnstile().then((turnstile) => {
      if (!active || !containerRef.current) return
      widgetId = turnstile.render(containerRef.current, {
        sitekey: env.turnstileSiteKey,
        action: 'turnstile-spin-v1',
        theme: 'light',
        language: language === 'ml' ? 'ml' : 'en',
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(''),
        'timeout-callback': () => onToken(''),
        'error-callback': () => { onToken(''); onError() },
      })
    }).catch(() => onError())
    return () => {
      active = false
      if (widgetId !== undefined && window.turnstile) window.turnstile.remove(widgetId)
    }
  }, [language, onError, onToken])

  return <div className={`turnstile-field ${verified ? 'is-verified' : ''}`}><div ref={containerRef} className="cf-turnstile" data-sitekey={env.turnstileSiteKey} data-action="turnstile-spin-v1" />{verified && <p className="turnstile-success" role="status"><span aria-hidden="true">✓</span>{verifiedLabel}</p>}</div>
}
